var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\nd-flex\nflex-row\nbg-danger\n",staticStyle:{"border-radius":"50rem","overflow":"hidden"}})}
var staticRenderFns = []

export { render, staticRenderFns }